import { render, staticRenderFns } from "./submitSuccess.vue?vue&type=template&id=15df1bc6&scoped=true&"
var script = {}
import style0 from "./submitSuccess.vue?vue&type=style&index=0&id=15df1bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15df1bc6",
  null
  
)

export default component.exports